import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import { remove } from 'lodash'
import queryString from 'query-string'
import { ShowMoreButton } from 'blocket-ui'
import { SelectLayout } from '@blazar-plugins/device'
import { svCompareString } from 'utils/sort'
import ListItem from '../ListItem'

const NUM_COLUMNS = 4
const GridList = styled.ul`
  padding: 8px 0;
  display: grid;
  grid-template-columns: repeat(${NUM_COLUMNS}, 1fr);
  ${({ showOrder: b }) => b && 'grid-auto-flow: column;'};
  ${({ showBorderTop: b }) => b && 'border-top: 0.5px solid #efefef;'};
  ${({ showOrder: b, items }) =>
    b && `grid-template-rows: repeat(${Math.ceil((items.length + 1) / 4)}, 1fr);`}
`

const ShowMoreButtonWrapper = styled.li`
  margin: 2px;
  display: flex;
  align-items: center;
  ${({ showOrder: b }) => (b ? '' : `grid-column: ${NUM_COLUMNS}`)};
`

const ShowMoreButtonLabelStyle = {
  fontSize: '15px',
}

export const LargeSecondLevel = ({
  items,
  trackQuickAssCategoryClick,
  onSecondLevelCategoryClick,
  external,
  breadcrumbs,
  intialShowItems = NUM_COLUMNS * 2,
  context,
}) => {
  const selectedItemIndex = items.findIndex((item) => item.selected === true)
  const [expanded, setExpanded] = useState(selectedItemIndex + 1 >= intialShowItems)
  const isBilarCategory = get(queryString.parse(context), 'cg', false) === '1020'
  let showItems
  if (expanded || items.length <= intialShowItems) {
    showItems = isBilarCategory
      ? [...items].sort((a, b) => svCompareString(a.label, b.label))
      : items
  } else {
    showItems = [...items].splice(0, intialShowItems - 1)
  }

  return (
    <GridList
      showBorderTop={breadcrumbs && breadcrumbs.length > 0}
      showOrder={isBilarCategory && expanded}
      items={items}
    >
      {showItems.map((item) => (
        <ListItem
          key={item.link}
          {...item}
          trackQuickAssCategoryClick={trackQuickAssCategoryClick}
          onSecondLevelCategoryClick={onSecondLevelCategoryClick}
          external={external}
        />
      ))}
      {items.length > intialShowItems && (
        <ShowMoreButtonWrapper showOrder={isBilarCategory && expanded} data-cy="quick-ass-show-more">
          <ShowMoreButton
            color="#363433"
            openLabel={isBilarCategory ? 'Visa A-Ö' : 'Visa alla'}
            closeLabel="Visa färre"
            labelStyle={ShowMoreButtonLabelStyle}
            onClick={() => setExpanded((currentExpanded) => !currentExpanded)}
            closed={expanded}
          />
        </ShowMoreButtonWrapper>
      )}
    </GridList>
  )
}

const SmallSecondLevel = ({
  items,
  trackQuickAssCategoryClick,
  onSecondLevelCategoryClick,
  external,
}) => {
  let listItems = items

  const isItemSelected = items.findIndex((item) => item.selected === true) !== -1

  if (isItemSelected) {
    const newItems = [...items]
    const selectedItem = remove(newItems, (item) => item.selected === true)
    newItems.unshift(selectedItem[0])

    listItems = newItems
  }

  return (
    <ul>
      {listItems.map((item) => (
        <ListItem
          key={item.link}
          {...item}
          trackQuickAssCategoryClick={trackQuickAssCategoryClick}
          onSecondLevelCategoryClick={onSecondLevelCategoryClick}
          external={external}
        />
      ))}
    </ul>
  )
}

export const SecondLevel = (props) => (
  <SelectLayout
    layouts={{
      large: <LargeSecondLevel {...props} />,
      small: <SmallSecondLevel {...props} />,
    }}
  />
)

SecondLevel.propTypes = {
  items: PropTypes.array.isRequired,
  trackQuickAssCategoryClick: PropTypes.func,
  onSecondLevelCategoryClick: PropTypes.func,
  external: PropTypes.bool,
  breadcrumbs: PropTypes.array,
}

LargeSecondLevel.propTypes = {
  ...SecondLevel.propTypes,
  intialShowItems: PropTypes.number,
}
SmallSecondLevel.propTypes = {
  ...SecondLevel.propTypes,
}

export default SecondLevel
